import ContaIndex from '../laisAccount/pages/ContaIndex.vue';
import { laisPath } from '../laisRouteHelpers';

export default {
  path: laisPath('comunidade/termo-consentimento'),
  component: ContaIndex,
  meta: {
    referenceAuthenticated: true,
  },
};
